import { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom"
import { CartContext } from "../context/CartContext"
import "./B2BDeals.css"

function B2BDeals(){

const [products,setProducts] = useState([])
const { addToCart } = useContext(CartContext)

useEffect(()=>{

fetch("/wp-json/wc/store/products")
.then(res=>res.json())
.then(data=>{
setProducts(data)
})

},[])

return(

<div className="b2bPage">

{/* HERO */}

<section
className="b2bHero"
style={{backgroundImage:"url(/images/sjb-banner.png)"}}
>

<div className="b2bOverlay">

<h1>Bulk Orders for Designers & Boutiques</h1>

<p>
Premium lace, gota patti and embroidery materials
available at wholesale prices.
</p>

</div>

</section>


{/* INTRO */}

<section className="b2bIntro">

<img src="/images/boutique.png" alt="boutique"/>

<h2>Our Bulk Lace Orders for Designers and Tailors</h2>

<p>
At S.G.T.B Company we are proud to be a leading
wholesale lace supplier offering premium quality
lace trims and tailoring materials across India.
</p>

</section>


{/* BULK FORM */}

<section className="b2bFormSection">

<h2>Bulk Order Inquiry</h2>

<form className="b2bForm">

<input type="text" placeholder="Your Name" required/>

<input type="email" placeholder="Your Email" required/>

<input type="tel" placeholder="Mobile"/>

<textarea placeholder="Your Message" rows="5"/>

<button type="submit">
Submit Inquiry
</button>

</form>

</section>


{/* HELP */}

<section className="b2bHelp">

<img src="/images/sewing-machine.png" alt="machine"/>

<p>
Feel free to contact our team with any queries and
we will help you select the best lace designs.
For larger orders we offer customization options
including fabric colors and thread combinations.
</p>

</section>


{/* WHY SGTB */}

<section className="whySJB">

<div className="whyText">

<h2>Why S.G.T.B?</h2>

<p>
S.G.T.B Company is dedicated to offering premium
lace and embroidery materials with craftsmanship
and precision.
</p>

<p>
Trusted by designers and boutiques across India,
we combine tradition with innovation to deliver
high quality products.
</p>

</div>

<div className="whyImage">

<img src="/images/sjb-banner.png" alt="S.G.T.B banner"/>

</div>

</section>


{/* PRODUCTS */}

<section className="b2bProducts">

<h2>Wholesale Deals</h2>

<div className="b2bGrid">

{products.map(product=>(

<div className="b2bCard" key={product.id}>

<Link to={`/product/${product.slug}`}>

<img
src={product.images?.[0]?.src}
alt={product.name}
/>

</Link>

<h3>{product.name}</h3>

<p className="price">
₹{Number(product.prices?.price) / 100}
</p>

<button
className="cartBtn"
onClick={()=>addToCart(product,1)}
>
Add to Cart
</button>

</div>

))}

</div>

</section>

</div>

)

}

export default B2BDeals